// `image.simple`: an image from a prompt (D3).
// Live's image list badge (`generations/generation/header`); its preview title is
// "Simple Generation" (`getPreviewTitle`).
import { ImageSimpleQuote, ImageSimpleRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"image.simple"> = {
  type: "image.simple",
  label: "Simple",
  detailTitle: "Simple Generation",
  source: "text",
  pair: "image.tweak",
  fields: (draft) => commonFields(draft),
  request: ImageSimpleRequest,
  quote: ImageSimpleQuote,
};
